import { render, staticRenderFns } from "./PersonalBanking.vue?vue&type=template&id=0ce27d4e&scoped=true"
import script from "./PersonalBanking.vue?vue&type=script&lang=js"
export * from "./PersonalBanking.vue?vue&type=script&lang=js"
import style0 from "./PersonalBanking.vue?vue&type=style&index=0&id=0ce27d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce27d4e",
  null
  
)

export default component.exports